import React from "react";
import nswGover from './../assets/logo/nswGover.png';

const Partners = () => {

  const partners = [
    {
      pic: nswGover,
      url: "https://www.nsw.gov.au/"
    },
    // Add more partners here
  ]

  return (
      <div className="flex flex-row flex-wrap content-start items-center justify-around">
        {[...partners].map((partner, index) => {
          return (
            partner.url ? 
            <a href={partner.url} key={`partner-${index}`} className="hover:opacity-80" target="_blank" rel="noreferrer">
              <div className="md:w-96 w-72 m-4 md:m-8"> {/* Further increased width for 1.5x larger images */}
                <img className="w-full" src={partner.pic} alt={`logo-partner-${index}`} />
              </div>
            </a>
            :
            <span key={`partner-${index}`}>
              <div className="md:w-96 w-72 m-4 md:m-8"> {/* Same increase for consistency */}
                <img className="w-full" src={partner.pic} alt={`logo-partner-${index}`} />
              </div>
            </span>
          )
        })}
      </div>
  )
}

export default Partners;